module.exports = __webpack_public_path__ + "static/media/llamadas.b8755f69.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Header/llamadas.svg
// module id = 1792
// module chunks = 0